import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import {setCookie,delCookie,delAllCookie} from '../assets/cookie'
/**
 * Vuex全局状态管理
 * options {Array} 用于渲染tabs的数组
 */
const store = new Vuex.Store({
  state: {
    hasLogin:sessionStorage.getItem('hasLogin')?sessionStorage.getItem('hasLogin'):false,
    token:sessionStorage.getItem('token'),
    userInfo: sessionStorage.getItem('userInfo'),
    cid:sessionStorage.getItem('cid')
  },
  mutations: {
    login (state, info) {
      state.userInfo = JSON.stringify(info)
      state.hasLogin = true
      state.token = info.token
      sessionStorage.setItem('userInfo',JSON.stringify(info))
      sessionStorage.setItem('hasLogin',true)
      sessionStorage.setItem('token',info.token)
      setCookie('token',info.token,43200)
    },
    logout(state) {
    	state.hasLogin = false
    	state.userInfo = {}
    	state.token = ''
    	delCookie('token')
    	sessionStorage.clear()
    },
    setCid(state, info) {
      state.cid=info
      sessionStorage.setItem('cid',info)
    },
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js